import React, { useState, useEffect } from "react";
import { Card, Col, Form, Row } from "react-bootstrap";

import { toast } from "react-hot-toast";
import { useParams } from "react-router-dom";
import CardHeader from "../../components/common/CardHeader";
import {
      FormButton,
      FormInput,
      FormSelect,
      FormStatusSelect,
      FormTextarea,
} from "../../components/form";
import LinkButton from "../../components/common/LinkButton";
import { privateApi } from "../../api";

const PluginEdit = () => {
      const { pluginId } = useParams();

      const [loadingData, setLoadingData] = useState(false);

      const [title, setTitle] = useState("");
      const [code, setCode] = useState("");
      const [type, setType] = useState("");
      const [tagType, setTagType] = useState("");
      const [status, setStatus] = useState("");
      const [loading, setLoading] = useState(false);

      const options = [
            {
                  id: "Body",
                  title: "Body",
            },
            {
                  id: "Header",
                  title: "Header",
            },
      ];

      const types = [
            {
                  id: "Meta",
                  title: "Meta",
            },
            {
                  id: "Script",
                  title: "Script",
            },
      ];

      const loadData = async () => {
            setLoadingData(true);
            await privateApi
                  .get(`/dashboard/plugins/${pluginId}`)
                  .then((response) => {
                        if (response.data.result === "success") {
                              setTitle(response.data.plugin.title);
                              setStatus(response.data.plugin.status);
                              setType(response.data.plugin.type);
                              setTagType(response.data.plugin.tag_type);
                              setCode(response.data.plugin.code);
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
            setLoadingData(false);
      };

      useEffect(() => {
            loadData();
      }, []);

      const handleForm = async (event) => {
            event.preventDefault();
            setLoading(true);
            const data = {
                  title: title,
                  code: code,
                  tag_type: tagType,
                  type: type,
                  status: status,
            };

            await privateApi
                  .post(`/dashboard/plugins/${pluginId}`, data)
                  .then((response) => {
                        if (response.data.result === "success") {
                              toast.success(response.data.message);
                        }
                        if (response.data.result === "error") {
                              if (response.data.message.title) {
                                    toast.error(response.data.message.title);
                              }
                              if (response.data.message.type) {
                                    toast.error(response.data.message.type);
                              }
                              if (response.data.message.code) {
                                    toast.error(response.data.message.code);
                              }
                              if (response.data.message.status) {
                                    toast.error(response.data.message.status);
                              }
                              if (response.data.message.tag_type) {
                                    toast.error(response.data.message.tag_type);
                              }
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
            setLoading(false);
      };

      return (
            <>
                  <Form onSubmit={handleForm}>
                        <Row>
                              <Col lg={12}>
                                    <Card>
                                          <CardHeader title="Edit Plugin">
                                                <LinkButton
                                                      title="Back"
                                                      link="/dashboard/plugins"
                                                />
                                          </CardHeader>
                                          <Card.Body>
                                                <Row className="g-3">
                                                      <FormInput
                                                            title="Title"
                                                            classes={8}
                                                            required={true}
                                                            value={title}
                                                            handleChange={
                                                                  setTitle
                                                            }
                                                      />
                                                      <FormSelect
                                                            loading={
                                                                  loadingData
                                                            }
                                                            title="Plugin Type"
                                                            selected={type}
                                                            required={true}
                                                            classes={4}
                                                            options={options}
                                                            setData={setType}
                                                      />
                                                      <FormSelect
                                                            options={types}
                                                            required={true}
                                                            classes={4}
                                                            title="Tag Type"
                                                            selected={tagType}
                                                            setData={setTagType}
                                                      />
                                                      <FormStatusSelect
                                                            title="Status"
                                                            classes={4}
                                                            selected={status}
                                                            setStatus={
                                                                  setStatus
                                                            }
                                                      />
                                                      <FormTextarea
                                                            title="Code"
                                                            required={true}
                                                            value={code}
                                                            handleChange={
                                                                  setCode
                                                            }
                                                      />
                                                </Row>
                                          </Card.Body>
                                    </Card>

                                    <Card className="mt-4 mb-5">
                                          <Card.Body>
                                                <Row>
                                                      <Col lg={12}>
                                                            <FormButton
                                                                  title="Submit"
                                                                  loading={
                                                                        loading
                                                                  }
                                                            />
                                                      </Col>
                                                </Row>
                                          </Card.Body>
                                    </Card>
                              </Col>
                        </Row>
                  </Form>
            </>
      );
};

export default PluginEdit;
